module.exports = __webpack_public_path__ + "static/media/fridge.bae43116.png";